interface ProductSettings {
  content_link: boolean
  content_file: boolean
  hardware_requirements: boolean
  supported_platforms: boolean
  no_score?: boolean
  no_skip?: boolean
  app_store_link?: boolean
  google_play_link?: boolean
  manager_approval?: boolean
}

interface ProductTypeSettings {
  act: ProductSettings
  activity: ProductSettings
  app: ProductSettings
  assessment: ProductSettings
  behavior: ProductSettings
  dialogue: ProductSettings
  fast_survey: ProductSettings
  fast: ProductSettings
  file: ProductSettings
  html: ProductSettings
  link: ProductSettings
  meet: ProductSettings
  operations: ProductSettings
  pdf: ProductSettings
  process_on_web: ProductSettings
  process: ProductSettings
  quiz_race: ProductSettings
  sim: ProductSettings
  skill: ProductSettings
  video: ProductSettings
  workflow: ProductSettings
  scorm: ProductSettings
  xapi: ProductSettings
  real_talk: ProductSettings
  real_talk_maker: ProductSettings
  skills_real_talk: ProductSettings
}

// scorm and xapi both surface as "SCORM" products and share identical settings.
// Use a single source of truth for both to avoid the two drifting apart.
const scormSettings: ProductSettings = {
  content_link: false,
  content_file: false,
  hardware_requirements: false,
  supported_platforms: true,
  manager_approval: false,
}

export const productTypeSettings: ProductTypeSettings = {
  activity: {
    content_link: false,
    content_file: false,
    no_score: true,
    hardware_requirements: false,
    supported_platforms: true,
    manager_approval: true,
  },
  pdf: {
    content_link: false,
    content_file: true,
    no_score: true,
    hardware_requirements: false,
    supported_platforms: true,
    manager_approval: false,
  },
  video: {
    content_link: true,
    content_file: false,
    no_score: true,
    no_skip: true,
    hardware_requirements: false,
    supported_platforms: true,
    manager_approval: false,
  },
  link: {
    content_link: true,
    content_file: false,
    no_score: true,
    hardware_requirements: false,
    supported_platforms: true,
    manager_approval: false,
  },
  html: {
    content_link: false,
    content_file: true,
    no_score: true,
    hardware_requirements: false,
    supported_platforms: true,
    manager_approval: false,
  },
  xapi: scormSettings,
  scorm: scormSettings,
  sim: {
    content_link: false,
    content_file: true,
    hardware_requirements: false,
    supported_platforms: true,
    manager_approval: false,
  },
  process: {
    content_link: false,
    content_file: true,
    hardware_requirements: false,
    supported_platforms: true,
    manager_approval: false,
  },
  behavior: {
    content_link: false,
    content_file: true,
    hardware_requirements: false,
    supported_platforms: true,
    manager_approval: false,
  },
  skill: {
    content_link: false,
    content_file: true,
    hardware_requirements: false,
    supported_platforms: true,
    manager_approval: false,
  },
  app: {
    content_link: true,
    content_file: false,
    no_score: true,
    app_store_link: true,
    google_play_link: true,
    hardware_requirements: false,
    supported_platforms: true,
    manager_approval: false,
  },
  meet: {
    content_link: false,
    content_file: false,
    app_store_link: false,
    google_play_link: false,
    hardware_requirements: false,
    supported_platforms: false,
    no_score: true,
    manager_approval: true,
  },
  file: {
    content_link: false,
    content_file: true,
    no_score: true,
    hardware_requirements: false,
    supported_platforms: false,
    manager_approval: false,
  },
  quiz_race: {
    content_link: true,
    content_file: false,
    no_score: true,
    hardware_requirements: false,
    supported_platforms: true,
    manager_approval: false,
  },
  fast: {
    content_link: false,
    content_file: false,
    hardware_requirements: false,
    supported_platforms: true,
    manager_approval: false,
  },
  dialogue: {
    content_link: false,
    content_file: false,
    hardware_requirements: false,
    supported_platforms: true,
    manager_approval: false,
  },
  fast_survey: {
    content_link: false,
    content_file: false,
    hardware_requirements: false,
    supported_platforms: true,
    manager_approval: false,
  },
  assessment: {
    content_link: false,
    content_file: false,
    hardware_requirements: false,
    supported_platforms: true,
    manager_approval: false,
  },
  process_on_web: {
    content_link: false,
    content_file: false,
    hardware_requirements: false,
    supported_platforms: true,
    manager_approval: false,
  },
  operations: {
    content_link: false,
    content_file: true,
    hardware_requirements: false,
    supported_platforms: true,
    manager_approval: false,
  },
  workflow: {
    content_link: false,
    content_file: true,
    hardware_requirements: false,
    supported_platforms: true,
    manager_approval: false,
  },
  act: {
    content_link: false,
    content_file: true,
    hardware_requirements: false,
    supported_platforms: true,
    manager_approval: false,
  },
  real_talk: {
    content_link: false,
    content_file: true,
    hardware_requirements: false,
    supported_platforms: true,
    manager_approval: false,
  },
  real_talk_maker: {
    content_link: false,
    content_file: true,
    hardware_requirements: false,
    supported_platforms: true,
    manager_approval: false,
  },
  skills_real_talk: {
    content_link: false,
    content_file: true,
    hardware_requirements: false,
    supported_platforms: true,
    manager_approval: false,
  },
}
